import React, { useState } from "react";
import Button from "components/buttons";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { postOcurrenceSource } from "../../../../services/commonService";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

export default function DialogAddOcurrenceSource({
  open,
  handleClose,
  intl,
  contractId,
  classes,
  eventType,
  occurrencesSourceToSelect
}) {


  const [occurrenceSource, setOccurrenceSource] = useState('');
  const [acceptDisabled, setAcceptDisabled] = useState(true);


  const selectOccurrence = event => {
         setOccurrenceSource(event.target.value);
         setAcceptDisabled(!event.target.value);
  };

 const sendNewoccurrenceSource = () => {

   postOcurrenceSource(
       occurrenceSource,
       {
         contract_id: contractId,
         event_type_id: eventType?.id,
       },
       handleClose,
   );
  }

  const handlePostOccurrenceSource = () => {
      sendNewoccurrenceSource();
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
            {intl.formatMessage({ id: "contract.ocurrenceSource.add" }) + ". "}
            {eventType?.description}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{intl.formatMessage({ id: "contract.ocurrenceSource.add.info" })}</DialogContentText>
            <Select
                labelId="occurrences-to-select"
                id="occurrences-to-select"
                className={classes.selectTypeEvent}
                onChange={selectOccurrence}
                value={occurrenceSource ? occurrenceSource : ''}
            >
                <MenuItem value="">
                    <em>{intl.formatMessage({ id: "asset.noselected" })}</em>
                </MenuItem>
                {occurrencesSourceToSelect &&
                occurrencesSourceToSelect.map(item => (
                    <MenuItem key={item} value={item}>
                        {item}
                    </MenuItem>
                ))}
            </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {intl.formatMessage({ id: "common.cancel" })}
          </Button>
          <Button onClick={handlePostOccurrenceSource} color="primary" disabled={acceptDisabled}>
            {intl.formatMessage({ id: "common.accept" })}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
